<app-confirm-delete-alert #confirmaction></app-confirm-delete-alert>
<ion-list>
  
  <ion-item *ngFor="let Token of Tokens">
    <ion-label class="">      
      <ion-text color="secondary">
        <h2 class="ion-text-wrap">{{Token.Model + " ("+(Token.Manufacturer ? Token.Manufacturer: manager.Trad.Parse("STR_UNKNOWN"))+")" }}</h2>
      </ion-text>
      <ion-text color="medium" >
        <p style="font-size: 14px;" class="text-ellipsis">{{Token.System+" - "+ Token.LastIp + " - " + Token.DisplayLastUse}}</p>
      </ion-text>
      <ion-text  color="primary">
        <p style="font-size: 10px; text-transform: uppercase; font-weight: bold; margin: 0">{{manager.Trad.Parse("STR_CREATED_AT", {date:Token.DisplayCreatedDate})}}</p>
      </ion-text>      
    </ion-label>
    
    <ion-item slot="end" lines="none" class="">

      
      <ion-button (click)="Delete(Token)" color="danger" >
        <ion-icon name="trash-outline"></ion-icon>
      </ion-button>
    </ion-item>
  </ion-item>
</ion-list>
